/* DARF Account Hub — orders, addresses, profile inside "Mein Hund".
   Renders into the bestellungen / adressen / konto view panels.
   Exposes window.__darfHubLoad{Orders,Addresses,Profile} called by setView.
   Auth + API base from window.__darfAuth (opaque session bearer token). */
(function () {
  'use strict';
  if (!window.__darfAuth) return;
  var AUTH = window.__darfAuth;
  var API = AUTH.api || 'https://api.darf-tiernahrung.de';

  function api(method, path, body) {
    // Token is minted asynchronously via the App Proxy; wait for it first.
    return Promise.resolve(AUTH.ready || AUTH.token).then(function () {
      var opts = { method: method, headers: { Authorization: 'Bearer ' + AUTH.token } };
      if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
      return fetch(API + path, opts);
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (d) {
        return { ok: r.ok, status: r.status, data: d };
      });
    });
  }
  function el(tag, opts, kids) {
    var n = document.createElement(tag);
    if (opts) {
      if (opts.cls) n.className = opts.cls;
      if (opts.text != null) n.textContent = String(opts.text);
      if (opts.attrs) Object.keys(opts.attrs).forEach(function (k) { n.setAttribute(k, opts.attrs[k]); });
      if (opts.on) Object.keys(opts.on).forEach(function (k) { n.addEventListener(k, opts.on[k]); });
    }
    (kids || []).forEach(function (c) { if (c) n.appendChild(c); });
    return n;
  }
  function clear(n) { while (n && n.firstChild) n.removeChild(n.firstChild); }
  function loading(n) { clear(n); n.appendChild(el('p', { cls: 'mh-muted', text: 'Lädt…' })); }
  function money(v, cur) { if (v == null) return ''; return Number(v).toFixed(2).replace('.', ',') + ' ' + (cur || 'EUR'); }
  function dt(s) { try { return new Date(s).toLocaleDateString('de-DE', { day: '2-digit', month: 'short', year: 'numeric' }); } catch (e) { return s; } }
  var FULFIL = { fulfilled: 'Versandt', partial: 'Teilweise versandt', unfulfilled: 'In Bearbeitung', restocked: 'Storniert', null: 'In Bearbeitung' };
  function status(o) { return FULFIL[o.fulfillment_status] || 'In Bearbeitung'; }

  /* ── Orders ── */
  var ordersBox;
  window.__darfHubLoadOrders = function () {
    ordersBox = ordersBox || document.getElementById('mh-orders');
    if (!ordersBox) return;
    loading(ordersBox);
    api('GET', '/accounts/orders').then(function (r) {
      if (!r.ok) { clear(ordersBox); ordersBox.appendChild(el('p',{cls:'mh-muted',text:'Bestellungen konnten nicht geladen werden.'})); return; }
      var orders = r.data.orders || [];
      clear(ordersBox);
      if (!orders.length) { ordersBox.appendChild(el('p', { cls: 'mh-muted', text: 'Noch keine Bestellungen.' })); return; }
      orders.forEach(function (o) {
        var head = el('div', { cls: 'mh-order__head' }, [
          el('div', {}, [
            el('strong', { text: o.name }),
            el('span', { cls: 'mh-muted', text: '  ' + dt(o.date) })
          ]),
          el('span', { cls: 'mh-pill', text: status(o) })
        ]);
        var meta = el('div', { cls: 'mh-order__meta' }, [
          el('span', { text: o.item_count + ' Artikel' }),
          el('strong', { text: money(o.total, o.currency) })
        ]);
        var actions = el('div', { cls: 'mh-order__actions' }, [
          el('button', { cls: 'mh-btn mh-btn--primary mh-btn--sm', text: 'Nochmal bestellen', on: { click: function () { reorder(o.id, this); } } }),
          o.status_url ? el('a', { cls: 'mh-btn mh-btn--ghost mh-btn--sm', text: 'Status & Beleg', attrs: { href: o.status_url, target: '_blank', rel: 'noopener' } }) : null
        ]);
        ordersBox.appendChild(el('div', { cls: 'mh-card mh-order' }, [head, meta, actions]));
      });
    });
  };
  /* Nochmal bestellen.

     Zwei Dinge gingen hier bis zum 28.09.2026 schief, und beide endeten in
     "der Knopf tut nichts": Shopify nimmt eine Sammelanfrage nur GANZ oder GAR
     NICHT an, also liess eine inzwischen ausverkaufte Position die ganze
     Nachbestellung scheitern; und die Antwort wurde nicht angesehen, der
     Browser sprang trotzdem auf /cart. Ein fetch scheitert nur am Netz, nicht
     an einem 422, also galt auch ein abgelehnter Warenkorb als Erfolg.

     Jetzt filtert der Server die nicht mehr lieferbaren Positionen heraus und
     benennt sie, und hier wird die Antwort wirklich geprueft. */
  function reorder(orderId, btn) {
    btn.disabled = true; btn.textContent = 'Wird hinzugefügt…';
    api('POST', '/accounts/reorder', { order_id: orderId }).then(function (r) {
      var items = (r.data && r.data.items) || [];
      var weg = (r.data && r.data.unavailable) || [];
      if (!items.length) {
        btn.disabled = false;
        btn.textContent = weg.length ? 'Nicht mehr lieferbar' : 'Nicht verfügbar';
        if (weg.length && window.DarfToast) DarfToast('Nicht mehr lieferbar: ' + weg.join(', '));
        return;
      }
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) { return res.json().then(function (d) { return { res: res, d: d }; }); })
        .then(function (x) {
          if (!x.res.ok || x.d.status) {
            btn.disabled = false; btn.textContent = 'Nochmal bestellen';
            if (window.DarfToast) DarfToast(x.d.description || x.d.message || 'Konnte nicht hinzugefügt werden');
            return;
          }
          // Was weggefallen ist, steht auf der Warenkorbseite, damit der Satz
          // den Seitenwechsel ueberlebt.
          if (weg.length) { try { sessionStorage.setItem('darf:reorder-weg', weg.join(', ')); } catch (e) {} }
          window.location.href = '/cart';
        })
        .catch(function () { btn.disabled = false; btn.textContent = 'Fehler'; });
    });
  }

  /* ── Addresses ── */
  var addrBox;
  window.__darfHubLoadAddresses = function () {
    addrBox = addrBox || document.getElementById('mh-addresses');
    if (!addrBox) return;
    loading(addrBox);
    api('GET', '/accounts/addresses').then(function (r) {
      clear(addrBox);
      var list = (r.data && r.data.addresses) || [];
      if (!r.ok) { addrBox.appendChild(el('p', { cls: 'mh-muted', text: 'Adressen konnten nicht geladen werden.' })); return; }
      if (!list.length) addrBox.appendChild(el('p', { cls: 'mh-muted', text: 'Noch keine Adresse gespeichert. Lege deine Lieferadresse an, dann geht der Checkout schneller.' }));
      list.forEach(function (a) { addrBox.appendChild(addressCard(a)); });
      addrBox.appendChild(el('button', { cls: 'mh-btn mh-btn--primary', text: '+ Neue Adresse', on: { click: function () { addrBox.insertBefore(addressForm(null), addrBox.firstChild); } } }));
    });
  };
  // Themed confirm (DarfConfirm from the pet profile module) with a native fallback.
  function confirmDelete() {
    if (window.DarfConfirm) {
      return window.DarfConfirm({ message: 'Diese Adresse wirklich löschen?', confirmLabel: 'Ja, löschen', cancelLabel: 'Abbrechen', danger: true });
    }
    return Promise.resolve(confirm('Adresse löschen?'));
  }
  function fmtAddr(a) {
    return [[a.first_name, a.last_name].filter(Boolean).join(' '), a.company, [a.address1, a.address2].filter(Boolean).join(', '),
      [a.zip, a.city].filter(Boolean).join(' '), a.province, a.country, a.phone].filter(Boolean).join(' · ');
  }
  function addressCard(a) {
    var actions = [
      el('button', { cls: 'mh-btn mh-btn--ghost mh-btn--sm', text: 'Bearbeiten', on: { click: function () { card.replaceWith(addressForm(a)); } } }),
      a.default ? el('span', { cls: 'mh-pill', text: 'Standard' })
                : el('button', { cls: 'mh-btn mh-btn--ghost mh-btn--sm', text: 'Als Standard', on: { click: function () { api('POST', '/accounts/addresses/' + a.id + '/default').then(window.__darfHubLoadAddresses); } } }),
      a.default ? null
                : el('button', { cls: 'mh-btn mh-btn--ghost mh-btn--sm mh-btn--danger', text: 'Löschen', on: { click: function () { confirmDelete().then(function (ok) { if (ok) api('DELETE', '/accounts/addresses/' + a.id).then(window.__darfHubLoadAddresses); }); } } })
    ];
    var card = el('div', { cls: 'mh-card mh-addr' }, [
      el('p', { text: fmtAddr(a) }),
      el('div', { cls: 'mh-order__actions' }, actions)
    ]);
    return card;
  }
  var AF = [['first_name', 'Vorname'], ['last_name', 'Nachname'], ['address1', 'Straße & Nr.'], ['address2', 'Zusatz'], ['zip', 'PLZ'], ['city', 'Stadt'], ['province', 'Bundesland'], ['country', 'Land'], ['phone', 'Telefon']];
  function addressForm(a) {
    a = a || {};
    var inputs = {};
    var fields = AF.map(function (f) {
      var inp = el('input', { cls: 'mh-input', attrs: { type: 'text', placeholder: f[1], value: a[f[0]] || (f[0] === 'country' ? 'Germany' : '') } });
      inputs[f[0]] = inp;
      return el('label', { cls: 'mh-field' }, [el('span', { text: f[1] }), inp]);
    });
    var save = el('button', { cls: 'mh-btn mh-btn--primary', text: 'Speichern', on: { click: function () {
      var body = {}; Object.keys(inputs).forEach(function (k) { body[k] = inputs[k].value; });
      var p = a.id ? api('PUT', '/accounts/addresses/' + a.id, body) : api('POST', '/accounts/addresses', body);
      p.then(window.__darfHubLoadAddresses);
    } } });
    var cancel = el('button', { cls: 'mh-btn mh-btn--ghost', text: 'Abbrechen', on: { click: window.__darfHubLoadAddresses } });
    return el('div', { cls: 'mh-card mh-addr-form' }, [el('div', { cls: 'mh-row' }, fields), el('div', { cls: 'mh-order__actions' }, [save, cancel])]);
  }

  /* ── Profile (account, not the dog) ── */
  window.__darfHubLoadProfile = function () {
    var box = document.getElementById('mh-konto');
    if (!box) return;
    loading(box);
    api('GET', '/accounts/profile').then(function (r) {
      var p = (r.data && r.data.profile) || {};
      clear(box);
      var fn = el('input', { cls: 'mh-input', attrs: { type: 'text', value: p.first_name || '' } });
      var ln = el('input', { cls: 'mh-input', attrs: { type: 'text', value: p.last_name || '' } });
      var ph = el('input', { cls: 'mh-input', attrs: { type: 'tel', value: p.phone || '' } });
      var mk = el('input', { attrs: { type: 'checkbox' } }); if (p.accepts_marketing) mk.checked = true;
      var msg = el('p', { cls: 'mh-muted' });
      var save = el('button', { cls: 'mh-btn mh-btn--primary', text: 'Speichern', on: { click: function () {
        save.disabled = true; msg.textContent = '';
        api('PATCH', '/accounts/profile', { first_name: fn.value, last_name: ln.value, phone: ph.value, accepts_marketing: mk.checked })
          .then(function (r) { save.disabled = false; msg.textContent = r.ok ? 'Gespeichert ✓' : 'Fehler beim Speichern'; });
      } } });
      box.appendChild(el('div', { cls: 'mh-card' }, [
        el('div', { cls: 'mh-row' }, [
          el('label', { cls: 'mh-field' }, [el('span', { text: 'Vorname' }), fn]),
          el('label', { cls: 'mh-field' }, [el('span', { text: 'Nachname' }), ln]),
          el('label', { cls: 'mh-field' }, [el('span', { text: 'Telefon' }), ph])
        ]),
        el('label', { cls: 'mh-field--checkbox' }, [mk, el('span', { text: ' Newsletter & Angebote erhalten' })]),
        el('label', { cls: 'mh-field' }, [el('span', { text: 'E-Mail (über Shopify verwaltet)' }),
          el('input', { cls: 'mh-input', attrs: { type: 'email', value: p.email || '', disabled: 'disabled' } })]),
        el('div', { cls: 'mh-order__actions' }, [save]), msg
      ]));
    });
  };
})();
